import { PalmettoButton, PalmettoIcon } from '@palmetto/dsm-components';
import type React from 'react';

export interface StaleTemplateVersionBannerProps {
  hasNewerTemplateVersion?: boolean;
  latestTemplateVersion?: number;
  canReplace?: boolean;
  isReplacing?: boolean;
  onReplace?: () => void;
}

export const StaleTemplateVersionBanner: React.FC<StaleTemplateVersionBannerProps> = ({
  hasNewerTemplateVersion,
  latestTemplateVersion,
  canReplace,
  isReplacing,
  onReplace,
}) => {
  if (!hasNewerTemplateVersion) return null;

  const message =
    latestTemplateVersion != null
      ? `A newer version (v${latestTemplateVersion}) of this checklist template exists.`
      : 'A newer version of this checklist template exists.';

  return (
    <div
      role="status"
      className="flex items-center gap-8 rounded-8 bg-notification-canvas-default px-12 py-10 text-notification-content-on-default-primary"
    >
      <PalmettoIcon name="infoSquare" size="sm" />
      <span className="body-300">{message}</span>
      {canReplace && (
        <PalmettoButton type="button" emphasis="secondary" size="small" disabled={isReplacing} onClick={onReplace}>
          Start Over With Latest Template
        </PalmettoButton>
      )}
    </div>
  );
};
